import React, { useEffect, useState } from 'react';
import './auth.css';
import { useAuth } from './AuthContext';

const OAuthCallback: React.FC = () => {
  const { consumeOAuthCode } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const oauthError = params.get('error');
    if (oauthError) {
      setError(params.get('error_description') || oauthError);
      return;
    }
    if (!code) {
      setError('No authorization code in URL');
      return;
    }
    consumeOAuthCode(code)
      .then(() => {
        // Strip ?code from history; AuthGate will re-render based on new state.
        window.history.replaceState({}, '', '/');
      })
      .catch((err: Error) => setError(err.message));
  }, [consumeOAuthCode]);

  if (error) {
    return (
      <div className="auth-container">
        <div className="auth-box">
          <h1>Sign-in failed</h1>
          <p className="subtitle">{error}</p>
          <button className="primary" onClick={() => { window.location.href = '/'; }}>
            Try again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h1>Finishing sign in…</h1>
      </div>
    </div>
  );
};

export default OAuthCallback;
